import classes from "../homePageNew.module.css";
import { RBI_WEIGHTS } from "../../../utils/brandIndexCalc";

/**
 * Conic-gradient donut, weighted exactly as the prototype's DONUT():
 * visibility/50, sentiment/50, brandPillars/10, purchaseCriteria/10, each scaled by its RBI_WEIGHTS share.
 */
function buildGradient(visibility, sentiment, brandPillars, purchaseCriteria) {
  const wv = (visibility / 50) * RBI_WEIGHTS.visibility;
  const ws = (sentiment / 50) * RBI_WEIGHTS.sentiment;
  const wp = (brandPillars / 10) * RBI_WEIGHTS.brandPillars;
  const wpc = (purchaseCriteria / 10) * RBI_WEIGHTS.purchaseCriteria;
  const total = wv + ws + wp + wpc || 1;
  const a = (wv / total) * 100;
  const b = ((wv + ws) / total) * 100;
  const c = ((wv + ws + wp) / total) * 100;
  return `conic-gradient(var(--hpn-d-blue) 0% ${a}%, var(--hpn-d-orange) ${a}% ${b}%, var(--hpn-d-purple) ${b}% ${c}%, var(--hpn-d-green) ${c}% 100%)`;
}

export default function ScoreDonut({ visibility, sentiment, brandPillars, purchaseCriteria, brandIndexScore }) {
  return (
    <div className={classes.donut} style={{ background: buildGradient(visibility, sentiment, brandPillars, purchaseCriteria) }}>
      <div className={classes.donutMid}>
        <span className={classes.num}>{brandIndexScore}</span>
        <span className={classes.lbl}>/100</span>
      </div>
    </div>
  );
}
